import { redirect } from 'react-router-dom'
import type { LoaderFunctionArgs } from 'react-router-dom'

import { useMeetingStore } from '@stores/meeting'
import { ROUTES } from '@constants/routes'

/**
 * Factory pour créer un loader de redirection meeting.
 *
 * Vérifie si une session meeting active existe.
 * Si non, redirige vers la waiting room pour forcer le flux complet.
 * Cela permet de gérer les accès directs à l'URL du meeting.
 */
function createMeetingRedirectLoader(waitingRoomRoute: (appointmentId: string) => string) {
  return async ({ params }: LoaderFunctionArgs) => {
    const { appointmentId, meetingId } = params

    if (!appointmentId || !meetingId) {
      console.warn('[meetingRedirectLoader] Paramètres manquants:', { appointmentId, meetingId })
      throw new Response("Paramètres d'URL invalides", { status: 400 })
    }

    const store = useMeetingStore.getState()
    const hasActiveSession = store.isActiveMeeting()
    const sessionMeetingId = store.meetingId

    if (!hasActiveSession || sessionMeetingId !== meetingId) {
      return redirect(waitingRoomRoute(appointmentId))
    }

    return null
  }
}

export const phoneMeetingRedirectLoader = createMeetingRedirectLoader(ROUTES.phoneWaitingRoom)
export const videoMeetingRedirectLoader = createMeetingRedirectLoader(ROUTES.videoWaitingRoom)
